// Landing page is served as static HTML (peppermintfi-landing.html)
// This component handles the /landing route or redirects appropriately
import { useEffect } from 'react'

export default function LandingPage() {
  // In production, this would be the full landing page component
  // For now, the landing page is in peppermintfi-landing.html
  return (
    <div style={{ minHeight: '100vh', background: '#0A0F0D', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 60, height: 60, borderRadius: 16, background: '#00C896', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, margin: '0 auto 20px', boxShadow: '0 0 30px rgba(0,200,150,0.4)' }}>🌿</div>
        <h1 style={{ fontFamily: 'Syne, sans-serif', color: '#E8F5EE', fontSize: 36, fontWeight: 800 }}>
          Peppermint<span style={{ color: '#00C896' }}>Fi</span>
        </h1>
        <p style={{ color: '#6B8F7A', marginTop: 12, marginBottom: 32 }}>Mint is gone. Your finances aren't.</p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <a href="/login" style={{ background: '#00C896', color: '#000', padding: '12px 28px', borderRadius: 10, textDecoration: 'none', fontWeight: 700, fontFamily: 'Syne, sans-serif' }}>
            Get Started Free
          </a>
          <a href="/pricing" style={{ background: 'transparent', color: '#E8F5EE', padding: '12px 28px', borderRadius: 10, textDecoration: 'none', border: '1px solid #1E2E24' }}>
            View Pricing
          </a>
        </div>
      </div>
    </div>
  )
}
